import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { HeaderLocation } from '../parts/HeaderLocation';
import { ConnectedFragmentHeader } from './FragmentHeader';
import { HeaderDatesSegments } from '../parts/HeaderDatesSegments';
import { HeaderPax } from '../parts/HeaderPax';
import { SegmentContext } from '../../../Segment/SegmentManager/Context';
import { ConnectedFaresTrackingCalculator } from '../../../../../components/Calendar/Context/FaresTrackingCalculator';
import { EntryPoint } from '../../../../../models';

export const FragmentHeaderSegment = ({ pax }) => {
    const { segment } = useContext(SegmentContext);
    const { date } = segment;
    const hasDate = !!date;

    return (
        <ConnectedFaresTrackingCalculator trackType='close_calendar'>
            {({ extraTracking }) => (
                <ConnectedFragmentHeader extraTracking={extraTracking}>
                    <HeaderLocation segment={segment} activeProduct={EntryPoint.FLIGHTS} />
                    { hasDate || !!pax && (
                        <div className='odf-text-center'>
                            <HeaderDatesSegments segments={[segment]} />
                            <HeaderPax pax={pax} />
                        </div>
                    )}
                </ConnectedFragmentHeader>
            )}
        </ConnectedFaresTrackingCalculator>
    );
};

FragmentHeaderSegment.propTypes = {
    pax: PropTypes.number,
};

FragmentHeaderSegment.defaultProps = {
    pax: 0,
};
